import { Navigate } from 'react-router-dom';
import HomePage from '../pages/home/page';
import CoursesPage from '../pages/courses/page';
import CourseDetailPage from '../pages/course-detail/page';
import LessonViewerPage from '../pages/lesson-viewer/page';
import DashboardPage from '../pages/dashboard/page';
import CertificatePage from '../pages/certificate/page';
import CourseDiscussionPage from '../pages/course-discussion/page';
import LoginPage from '../pages/auth/login/page';
import SignupPage from '../pages/auth/signup/page';
import NotFound from '../pages/NotFound';
import RoleRoute from '../Routes/RoleRoute';
import AdminLayout from '../pages/admin/components/AdminLayout';
import AdminDashboardPage from '../pages/admin/dashboard/page';
import AdminCoursesPage from '../pages/admin/courses/page';
import CourseEditorPage from '../pages/admin/course-edit/page';
import AdminInstructorsPage from '../pages/admin/instructors/page';
import AdminUsersPage from '../pages/admin/users/page';
import AdminContentPage from '../pages/admin/content/page';
import AdminOrganizationPage from '../pages/admin/organization/page';
import AdminBillingPage from '../pages/admin/billing/page';
import AdminAnalyticsPage from '../pages/admin/analytics/page';
import OrgCatalogPage from '../pages/org-catalog/page';

const routes = [
  { path: '/', element: <HomePage /> },
  { path: '/courses', element: <CoursesPage /> },
  { path: '/courses/:id', element: <CourseDetailPage /> },
  { path: '/courses/:courseId/lesson/:lessonId', element: <LessonViewerPage /> },
  { path: '/courses/:courseId/discussion', element: <CourseDiscussionPage /> },
  { path: '/dashboard', element: <DashboardPage /> },
  { path: '/certificate/:courseId', element: <CertificatePage /> },
  { path: '/o/:slug', element: <OrgCatalogPage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/signup', element: <SignupPage /> },
  {
    path: '/admin',
    element: (
      <RoleRoute allowedRoles={['superadmin', 'admin', 'instructor']}>
        <AdminLayout />
      </RoleRoute>
    ),
    children: [
      { index: true, element: <Navigate to="/admin/dashboard" replace /> },
      { path: 'dashboard', element: <AdminDashboardPage /> },
      { path: 'courses', element: <AdminCoursesPage /> },
      { path: 'courses/new', element: <CourseEditorPage /> },
      { path: 'courses/:id/edit', element: <CourseEditorPage /> },
      { path: 'content', element: <AdminContentPage /> },
      { path: 'organization', element: <AdminOrganizationPage /> },
      { path: 'billing', element: <AdminBillingPage /> },
      { path: 'analytics', element: <AdminAnalyticsPage /> },
      { path: 'instructors', element: <AdminInstructorsPage /> },
      { path: 'users', element: <AdminUsersPage /> },
    ],
  },
  { path: '*', element: <NotFound /> },
];

export default routes;

